import React, { Component } from "react";
import { Link } from "react-router-dom";
//import FbIcon from "../images/icons/facebook-box.png";
//import InstaIcon from "../images/icons/instagram.png";
import Language from "./Language";
import { scrollTo } from "scroll-js";
import { connect } from "react-redux";

//import { changeLanguage } from "../actions";

class Menu extends Component {
	state = {
		menuButton: false,
		mainMenu: true,
		menuClass: null,
		socialIconsClass: null
	};

	resizeWindow = () => {
		if (window.innerWidth < 800) {
			this.setState({
				mainMenu: false
			});
		} else {
			this.setState({
				mainMenu: true
			});
		}
	};

	windowScroll = () => {
		if (window.pageYOffset >= 150) {
			this.setState({
				menuClass: " navShadow",
				socialIconsClass: " hidden"
			});
		} else {
			this.setState({
				menuClass: "",
				socialIconsClass: ""
			});
		}
	};

	componentWillUnmount() {
		window.removeEventListener("resize", this.resizeWindow);
		window.removeEventListener("scroll", this.windowScroll);
	}

	componentDidMount() {
		if (window.innerWidth < 800) {
			this.setState({
				mainMenu: false
			});
		} else {
			this.setState({
				mainMenu: true
			});
		}
		if (window.pageYOffset > 150) {
			this.setState({
				menuClass: " navShadow",
				socialIconsClass: " hidden"
			});
		}

		window.addEventListener("resize", this.resizeWindow);

		window.addEventListener("scroll", this.windowScroll);
	}

	componentDidUpdate() {
		if (this.state.menuButton) {
			const overlay = document.querySelector(".overlay");
			setTimeout(() => {
				overlay && overlay.classList.add("open");
			}, 100);
		}
	}

	menuSwitch = (e) => {
		this.setState({
			menuButton: !this.state.menuButton
		});
	};

	store = this.props.store;

	// clickHandler = () => {
	//   this.store.dispatch(changeLanguage("english"));
	// };

	scroll = (index) => {
		if (window.innerWidth < 800) {
			this.menuSwitch();
		}
		scrollTo(document.body, {
			duration: 1000,
			top: document.querySelector(index).offsetTop - 100,
			easing: "ease-in-out"
		});
		// scrollTo(document.body, {
		// 	top: index,
		// 	duration: 1000,
		// 	easing: "ease-out"
		// }).then(() => {});
	};

	render() {
		const { langBase, activeMenu } = this.props;

		return (
			<div className={`menu ${this.state.menuClass}`} style={{ top: 0 }}>
				<div
					onClick={this.menuSwitch}
					className={`logo icon button_container ${this.state.menuButton && "active"}`}
					id="toggle">
					<span className="top" /> <span className="middle" />
					<span className="bottom" />
				</div>
				{this.state.mainMenu && (
					<nav>
						<li className={activeMenu === 1 ? "active" : ""}>
							<Link to="/" onClick={() => this.scroll(".slogan")}>
								{langBase.home}
							</Link>
						</li>
						<li className={activeMenu === 2 ? "active" : ""}>
							<Link to="/" onClick={() => this.scroll(".calculator-view")}>
								{langBase.calculator}
							</Link>
						</li>
						<li className={activeMenu === 3 ? "active" : ""}>
							<Link to="/" onClick={() => this.scroll("#price-table")}>
								{langBase.prices}
							</Link>
						</li>
						<li className={activeMenu === 4 ? "active" : ""}>
							<Link to="/" onClick={() => this.scroll("#portfolio")}>
								{langBase.fotovideo}
							</Link>
						</li>
						<li className={activeMenu === 5 ? "active" : ""}>
							<Link to="/" onClick={() => this.scroll("#testimonial-block")}>
								{langBase.opinion}
							</Link>
						</li>
						<li className={activeMenu === 6 ? "active" : ""}>
							<Link to="/" onClick={() => this.scroll("#contact")}>
								{langBase.contact}
							</Link>
						</li>
					</nav>
				)}

				<div className="social-icons">
					{/* <img className={this.state.socialIconsClass} src={FbIcon} alt="" />
          <img className={this.state.socialIconsClass} src={InstaIcon} alt="" /> */}
					<div className="language">
						<Language store={this.store} />
					</div>
				</div>
				{this.state.menuButton && (
					<div className="overlay" id="overlay">
						<nav className="overlay-menu" style={{ padding: 0 }}>
							<li>
								<Link to="/" onClick={() => this.scroll(".slogan")}>
									{langBase.home}
								</Link>
							</li>
							<li>
								<Link to="/" onClick={() => this.scroll(".calculator-view")}>
									{langBase.calculator}
								</Link>
							</li>
							<li>
								<Link to="/" onClick={() => this.scroll("#portfolio")}>
									{langBase.fotovideo}
								</Link>
							</li>
							<li>
								<Link to="/" onClick={() => this.scroll("#price-table")}>
									{langBase.prices}
								</Link>
							</li>
							<li>
								<Link to="/" onClick={() => this.scroll("#testimonial-block")}>
									{langBase.opinion}
								</Link>
							</li>
							<li>
								<Link to="/" onClick={() => this.scroll("#contact")}>
									{langBase.contact}
								</Link>
							</li>
						</nav>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	activeMenu: state.activeMenu
});

export default connect(mapStateToProps)(Menu);
